import { Box } from "@mui/material";
import { add } from "date-fns";
import { path } from "ramda";
import { useMemo, useState } from "react";
import { ButtonGroupSelect } from "../../components/ButtonGroupSelect/ButtonGroupSelect";
import { Layout } from "../../components/Layout";
import { useMsg } from "../../components/Msg/Msg";
import { LinearProgressWithLabel } from "../../components/Progress/LinearProgressWithLabel";
import { StyledTableCell, TLCell, UserCell } from "../../components/Table";
import { TLTableWithHeader } from "../../components/Table/TLTableWithHeader";
import { H2 } from "../../components/Typography";
import { useReportSessionsQuery } from "./api";
import { reportsMessages } from "./messages";

const TIMEFRAME = {
  ALL: "ALL",
  YEAR: "YEAR",
  MONTH: "MONTH",
  WEEK: "WEEK",
  DAY: "DAY",
};

export const ReportsPage = () => {
  const msg = useMsg({ dict: reportsMessages });
  const [timeframe, setTimeframe] = useState(TIMEFRAME.ALL);

  const fromDate = useMemo(() => {
    const subtract = {
      ALL: undefined,
      YEAR: { years: -1 },
      MONTH: { months: -1 },
      WEEK: { weeks: -1 },
      DAY: { days: -1 },
    }[timeframe];
    if (!subtract) return undefined;
    return add(new Date(), subtract);
  }, [timeframe]);
  const reportSessionsQuery = useReportSessionsQuery({ from: fromDate });

  const columns = [
    {
      label: msg("reports.table.col.name"),
      key: "name",
      render: (row) => (
        <UserCell
          email={row.username}
          firstName={row.firstName}
          lastName={row.lastName}
        />
      ),
    },
    {
      label: msg("reports.table.col.bookedSessions"),
      key: "booked",
      render: (row) => <TLCell>{row.booked ?? 0}</TLCell>,
    },
    {
      label: msg("reports.table.col.attendedSessions"),
      key: "attended",
      render: (row) => <TLCell>{row.attended ?? 0}</TLCell>,
    },
    // {
    //   label: msg("reports.table.col.attendedStats"),
    //   key: "attendedStats",
    //   render: (row) => {
    //     const attended = row.attended ?? 0;
    //     const booked = row.booked ?? 0;
    //     const total = booked + attended; // TODO: unattended?
    //     const percent = (attended / total) * 100 || 0;
    //     return (
    //       <StyledTableCell>
    //         <LinearProgressWithLabel value={percent} />
    //       </StyledTableCell>
    //     );
    //   },
    // },
  ];
  const timeframeOptions = useMemo(
    () => [
      {
        label: msg("reports.timeframe-filter.options.all"),
        value: TIMEFRAME.ALL,
      },
      {
        label: msg("reports.timeframe-filter.options.year"),
        value: TIMEFRAME.YEAR,
      },
      {
        label: msg("reports.timeframe-filter.options.month"),
        value: TIMEFRAME.MONTH,
      },
      {
        label: msg("reports.timeframe-filter.options.week"),
        value: TIMEFRAME.WEEK,
      },
      {
        label: msg("reports.timeframe-filter.options.day"),
        value: TIMEFRAME.DAY,
      },
    ],
    [msg],
  );

  // const diff = 5;

  //       return (
  //         <TLCell>
  //           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  //             <div
  //               style={{
  //                 position: "relative",
  //                 width: "100px",
  //                 height: "8px",
  //                 backgroundColor: "#eee",
  //                 borderRadius: "4px",
  //               }}
  //             >
  //               <div
  //                 style={{
  //                   width: `${percent}%`,
  //                   height: "100%",
  //                   backgroundColor: "#5E3FC9", // fialová z obrázku
  //                   borderRadius: "4px",
  //                 }}
  //               ></div>
  //             </div>
  //             <span>{percent}</span>
  //             <span
  //               style={{
  //                 backgroundColor: diff >= 0 ? "#DCFCE7" : "#FEE2E2",
  //                 color: diff >= 0 ? "#15803D" : "#B91C1C",
  //                 fontWeight: "bold",
  //                 fontSize: "0.8rem",
  //                 padding: "2px 6px",
  //                 borderRadius: "999px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 gap: "4px",
  //               }}
  //             >
  //               <span>{diff >= 0 ? "↑" : "↓"}</span>
  //               {Math.abs(diff)}%
  //             </span>
  //           </div>
  //         </TLCell>
  //       );
  //     },
  //   },
  // ];

  return (
    <Layout header={{ heading: msg("reports.title") }}>
      <ButtonGroupSelect
        variant="outlined"
        selected={timeframe}
        onSelect={({ value }) => setTimeframe(value)}
        options={timeframeOptions}
        sx={{ mb: 3 }}
      />
      <TLTableWithHeader
        title={
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              minHeight: 30,
            }}
          >
            <H2>{msg("reports.subtitle")}</H2>
          </Box>
        }
        columns={columns}
        query={reportSessionsQuery}
        getRowsFromQuery={path(["data", "content"])}
      />
    </Layout>
  );
};
